import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getCaseStudy } from "@/data/caseStudies";
import SEO from "@/components/SEO";

export default function BlogDetail() {
  const { slug } = useParams();
  const art = getCaseStudy(slug);

  if (!art) return <div className="section-pad text-center text-[#5A6058]">Caso studio non trovato. <Link to="/casistudio" className="text-[#323C36] underline">Torna ai casi studio</Link></div>;

  return (
    <article className="section-pad">
      <SEO
        path={`/casistudio/${art.slug}`}
        title={art.title}
        description={art.excerpt}
        image={art.cover}
        type="article"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": art.title,
          "description": art.excerpt,
          "image": art.cover,
          "datePublished": art.date,
          "author": {"@type":"Person","name": art.author, "url":"https://robertacastagna.it/chi-sono"},
          "publisher": {"@type":"Organization","name":"Roberta Castagna","logo":{"@type":"ImageObject","url":"https://robertacastagna.it/assets/logo-primary.png"}},
          "articleSection": art.category,
          "inLanguage": "it-IT",
          "mainEntityOfPage": `https://robertacastagna.it/casistudio/${art.slug}`
        }}
      />
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <Link data-testid="back-to-blog" to="/casistudio" className="inline-flex items-center gap-2 text-sm text-[#323C36] mb-8"><ArrowLeft size={14}/> Tutti gli articoli</Link>
        <p className="eyebrow mb-4">{art.category}</p>
        <h1 data-testid="article-title" className="font-display text-4xl sm:text-5xl leading-tight text-[#2A3229]">{art.title}</h1>
        <p className="mt-4 text-sm text-[#5A6058]">di {art.author} · {new Date(art.date).toLocaleDateString("it-IT",{year:"numeric",month:"long",day:"numeric"})}</p>
        <div className="aspect-[16/9] overflow-hidden my-10">
          <img src={art.cover} alt={art.title} className="w-full h-full object-cover" />
        </div>
        <div className="space-y-4 text-[#2A3229] leading-relaxed text-lg">
          {art.content.split("\n\n").map((p,i) => {
            if (p.startsWith("## ")) {
              return <h2 key={i} className="font-display text-2xl sm:text-3xl text-[#323C36] mt-8 mb-2">{p.replace(/^## /, "")}</h2>;
            }
            // render **bold** inline
            const parts = p.split(/(\*\*[^*]+\*\*)/g);
            return (
              <p key={i}>
                {parts.map((seg, j) => seg.startsWith("**")
                  ? <strong key={j} className="text-[#2A3229]">{seg.slice(2,-2)}</strong>
                  : <span key={j}>{seg}</span>)}
              </p>
            );
          })}
        </div>
        <div className="mt-16 border-t border-[#323C36]/15 pt-10">
          <p className="eyebrow mb-2">Vuoi approfondire?</p>
          <p className="font-display text-2xl text-[#2A3229] mb-6">Scopri il check-up aziendale o prenota una call di orientamento.</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/checkup" className="btn-ghost-accent" data-testid="article-cta-quiz">Check‑Up Aziendale</Link>
            <Link to="/contatti" className="btn-secondary" data-testid="article-cta-contact">Contattami</Link>
          </div>
        </div>
      </div>
    </article>
  );
}
